<template>
  <div class="modal1Back">
    <div class="modal1">
        <p class="modal1__title">Добавьте фото для вашей программы</p>
        <div class="modal1__block">
            <div class="modal1__block__image" v-for="(image, index) in images" :key="index">
                <img :src="image.preview" alt="Uploaded Image" />
                <button class="modal1__block__delete" @click="removeImage(index)">
                    <img src="@/assets/icons/delete.svg"/>
                </button>
            </div>
            <label class="modal1__block__in" for="addPhoto">
                <img src="@/assets/icons/plus.svg"/>
                <input 
                    type="file" 
                    multiple
                    id="addPhoto" 
                    style="display: none;" 
                    @change="handleFileChange" />
            </label>
        </div>
        <div class="modal1__buttons">
            <button class="modal1__buttons__save" @click="saveChanges">Отправить</button>
            <button class="modal1__buttons__delete" @click="cancelChanges">Закрыть</button>
        </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import axios from 'axios';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
const props = defineProps({
    universityProgramId: {
        type: Number,
        required: true
    }
});
const images = ref([]);
const removeImage = (index) => {
  images.value.splice(index, 1);
};
const emit = defineEmits(['closeModal']);
const cancelChanges = () => {
    images.value = [];
    emit('closeModal');
};
const handleFileChange = (event) => {
  const files = event.target.files;
  if (files.length > 0) {
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const reader = new FileReader();
      reader.onload = (e) => {
        images.value.push({
          file: file,
          preview: e.target.result
        });
      };
      reader.readAsDataURL(file);
    }
  }
};
const saveChanges = () => {
  const formData = new FormData();
  images.value.forEach((imgObj, index) => {
    formData.append(`image[${index}]`, imgObj.file); // <-- File, не строка
  });
  formData.append('university_program_id', props.universityProgramId); // используй props
  axios.post(`/V1/universityProgramsImages`, formData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
  })
  .then((response) => {
    if (response.status === 200) {
      toast.success('Успешно отправлено')
      emit('closeModal');
    }
  })
  .catch((error) => {
    console.error(error);
  });
};
</script>

<style lang="scss" scoped>
.modal1{
    width: 50%;
    &__title{
        font-size: 20px;
        font-weight: 600;
        text-align: center;
    }
    &__block{
        display: flex;
        flex-wrap: wrap;
        gap: 1.25%;
        &__delete{
            position: absolute;
            top: 5px;
            right: 5px;
            background-color: white;
            border: none;
            cursor: pointer;
            border-radius: 10px;
            img{
                width: 15px;
                height: 15px;
                object-fit: fill !important;
                border-radius: 0 !important;
            }
        }
        &__image{
            width: 19%;
            aspect-ratio: 1;
            background-color: #F8F8F8;
            display: flex;
            box-shadow: 0px 0px 8px 4px #0000000D inset;
            border: 1px solid #0000001A;
            border-radius: 10px;
            position: relative;
            img{
                width: 100%;
                aspect-ratio: 1;
                object-fit: cover;
                border-radius: 10px;
            }
        }
        &__in{
            width: 19%;
            aspect-ratio: 1;
            background-color: #F8F8F8;
            display: flex;
            box-shadow: 0px 0px 8px 4px #0000000D inset;
            border: 1px solid #0000001A;
            border-radius: 10px;
            cursor: pointer;
            img{
                width: 50%;
                height: 50%;
                margin: auto;
            }
        }
    }
    &__buttons{
        display: flex;
        width: 100%;
        gap: 4%;
        button{
            width: 48%;
            border: none;
            height: min(max(25px, calc(1.5625rem + ((1vw - 7.68px) * 2.1701))), 50px);
            border-radius: 10px;
        }
        &__save{
            color: white;
            font-size: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
            background-color: #11415D;
            border: 1px solid #11415D;
            transition: all 0.5s ease;
            &:hover{
                color: white;
                background-color: #2076a7;
            }
        }
        &__delete{
            background-color: inherit;
            border: 1px solid #0000001A !important;
            color: #0000008A;
            font-size: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
            transition: all 0.5s ease;
            &:hover{
                color: white;
                background-color: #11415D;
                border: 1px solid #11415D;
            }
        }
    }
}
</style>